"use client";

import Link from "next/link";
import { GENERATE_LEAD_EVENT, trackEvent } from "@/utils/gtm";

type DestinationSearchButtonProps = {
  destination: string;
  href: string;
  primaryKeyword: string;
};

export default function DestinationSearchButton({
  destination,
  href,
  primaryKeyword,
}: DestinationSearchButtonProps) {
  return (
    <Link
      href={href}
      onClick={() => {
        trackEvent(GENERATE_LEAD_EVENT, {
          lead_type: "hotel_search",
          destination,
          keyword: primaryKeyword,
        });
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 48,
        padding: "0 22px",
        borderRadius: 8,
        background: "var(--accent)",
        color: "#fff",
        fontWeight: 700,
        textDecoration: "none",
      }}
    >
      Search {destination} hotels
    </Link>
  );
}
